import HomePage from 'pages/HomePage';
import RegisterPage from 'pages/RegisterPage';
import BulkOrderPage from 'pages/BulkOrderPage';
import AddAddressPage from 'pages/AddAddressPage';

const routes = {
  public(mixpanel) {
    return [
      {
        path: '/',
        component: <HomePage />,
      },
      {
        path: '/register',
        component: <RegisterPage mixpanel={mixpanel} />,
      },
    ];
  },
  private() {
    return [
      {
        path: '/addAddress',
        component: <AddAddressPage />,
      },
      {
        path: '/bulkOrder',
        component: <BulkOrderPage />,
      },
    ];
  },
};

export default routes;
